import {
    resolveKernelByCommandAsync,
    sanitizeCommand,
} from "./kernelStore.js";

/**
 * Resolve the latest saved kernel for ChatConsole's post-save "Try" action.
 * Resolution failures are returned as user-facing state rather than escaping
 * as an unhandled click-handler rejection.
 */
export async function loadKernelForTry(command) {
    const sanitized = sanitizeCommand(command);
    if (!sanitized) {
        return { command: null, resolvedDefinition: null, error: null };
    }
    try {
        return {
            command: sanitized,
            resolvedDefinition: await resolveKernelByCommandAsync(null, sanitized),
            error: null,
        };
    } catch (error) {
        return {
            command: sanitized,
            resolvedDefinition: null,
            error: `Could not load /${sanitized}: ${error?.message || error}`,
        };
    }
}
